module.exports = __webpack_public_path__ + "img/holded.f1c9364d.png";